var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3953 19.2979L26.579 26.4796M1.76538 8.00863L5.23088 8.9387M3.2361 16.3461L5.77359 13.8107M7.8471 1.92899L8.7751 5.39241M16.1846 3.3997L13.6471 5.93513M15.0391 26.4651L9.93302 11.1738C9.87179 10.9911 9.86271 10.795 9.90681 10.6075C9.95091 10.4199 10.0464 10.2484 10.1827 10.1122C10.3189 9.97597 10.4904 9.88044 10.6779 9.83634C10.8655 9.79224 11.0616 9.80132 11.2442 9.86256L26.5355 14.9645C26.7429 15.034 26.9229 15.1675 27.0498 15.3456C27.1766 15.5238 27.2439 15.7375 27.2418 15.9562C27.2397 16.1749 27.1685 16.3874 27.0382 16.5631C26.908 16.7388 26.7255 16.8688 26.5169 16.9344L19.7951 19.0473C19.6358 19.0968 19.4909 19.1841 19.3726 19.3016C19.2543 19.4192 19.1662 19.5636 19.1157 19.7226L17.007 26.4464C16.9418 26.6558 16.8119 26.8391 16.636 26.97C16.46 27.1008 16.247 27.1725 16.0277 27.1745C15.8085 27.1766 15.5942 27.109 15.4158 26.9815C15.2374 26.854 15.104 26.6732 15.035 26.4651H15.0391Z",
    stroke: "#1B47C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurser);
export default __webpack_public_path__ + "static/media/Curser.e621838744939bc00056617be79932c3.svg";
export { ForwardRef as ReactComponent };